import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const resetProductSchemaAndConfig = createAsyncThunk<
    { data: any; guid: string },
    string,
    ThunkConfig<string>
>('configsSlice/resetProductSchemaAndConfig', async (guid, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get(
            getUrlWithVersion(`/schema_and_configuration/${guid}`)
        )
        return { data, guid }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to reset configuration ')
    }
})
